import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/_services/project.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/_services/data.service';
import 'codemirror/lib/codemirror';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/hint/sql-hint';
import 'codemirror/mode/sql/sql';
import 'codemirror/addon/fold/brace-fold';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';


@Component({
  selector: 'app-manage-sql-script',
  templateUrl: './manage-sql-script.component.html',
  styleUrls: ['./manage-sql-script.component.scss']
})
export class ManageSqlScriptComponent implements OnInit {

  sqlDataForm: UntypedFormGroup;
  projectName: any;
  submitted = false;
  url: string;
  title: any;
  projectId: string;
  testData: any;
  projectData: Object;
  updateForm: boolean = false;
  scriptDataById: any;
  executionMode = ["SEQUENTIAL", "PARALLEL"];
  public searchString: string;
  default = 'default';
  editorOptions = {
    theme: 'eclipse',
    mode: 'sql',
    lineNumbers: true,
    lineWrapping: true,
    foldGutter: true,
    autoCloseBrackets: true,
    matchBrackets: true,
    extraKeys: { 'Ctrl-Space': "autocomplete" }
  }
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Manage SQl Script',
    data: undefined,
  }
  currentUrl: any;
  previousUrl: any=[];
  previousUrltemp: any;
  agentCheck: boolean;


  constructor(
    private dataService: DataService,
    private formBuilder: UntypedFormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private project: ProjectService,
    private toastrService: ToastrService,
    private router:Router,
    private urlService: UrlService,
    private memoryService: MemoryService,
    private homeService: HomeService,
    private confirmationDialogService: ConfirmationDialogService) {
    this.url = environment.baseUrl
  }

  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        setTimeout(() => {
          this.getTestData();
          this.project.getProjectById(this.projectId).subscribe((
            data => {
              this.projectData = data;
              this.headerOptions.data = {
                projectId: this.projectId,
                projectName: data['projectName']
              };
              //set header details
              this.homeService.setHeaderOptions(this.headerOptions);
              //console.log(this.projectData);
              // this.projectName = this.projectData.projectName
            }
          ))
        }, 0)

      }
    )
    //console.log(this.projectId);
    this.loadForm();
    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }
  getTestData() {
    this.dataService.getSqlTestData(this.projectId).subscribe(
      (data) => {
        this.testData = data['sqlQueryData'];
        // TreeData = this.projectdata;
        // this.dataSource = this.projectdata;
        //console.log('test>>', this.testData);

      });
  }
  delRow(id) {
    this.confirmationDialogService.openConfirmDialog('Do you want to delete ?')
      .afterClosed().subscribe(res => {
        if (res) {
          //console.log('hello Delete')
          this.dataService.deleteSqlTestData(this.projectId, id).subscribe(
            (data) => {
              this.getTestData();
              this.updateForm = false;
              this.toastrService.clear();
              this.toastrService.success(' SQL Script  Deleted Successfully');
              this.ClearForm();
            }
          );
        }
      });
  }
  loadForm() {
    this.sqlDataForm = this.formBuilder.group({
      name: ['', Validators.required],
      settingName: ['',Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)],
      // runType:[],
      query: ['']
    })
  }

  get f() { return this.sqlDataForm.controls; }
  onsqlData() {
    this.submitted = true;
    if (this.sqlDataForm.invalid) {
      return;
    }
    var objFormval = this.sqlDataForm.value;

    if (this.updateForm === true) {
      const ValueForUpdate = {
        id: this.scriptDataById[0].id,
        name: objFormval.name,
        settingName: objFormval.settingName,
        // runType:objFormval.runType,
        query: objFormval.query,
        projectId: this.projectId,

        //  parentTestDataId: this.parentTestDataId
      }

      //console.log(ValueForUpdate)

      this.http.put(this.url + '/HuLoopRest/huloop/sqlQueryData', ValueForUpdate).subscribe((data) => {
        if (data) {
          this.testData = data;
          this.getTestData();
          this.ClearForm();
          this.toastrService.clear();
          this.toastrService.success('SQL Script Updated Successfully')
          this.updateForm = false;

        }
      });
    }
    if (this.updateForm === false) {
      const ValueForAdd = {
        name: objFormval.name,
        settingName: objFormval.settingName,
        // runType:"SEQUENTIAL",
        query: objFormval.query,
        projectId: this.projectId,
        //  parentTestDataId: this.parentTestDataId
      }


      this.http.post(this.url + '/HuLoopRest/huloop/sqlQueryData', ValueForAdd).subscribe((data) => {
        if (data) {
          this.getTestData();
          this.ClearForm();
          this.toastrService.clear();
          this.toastrService.success('SQL Script Created Successfully')
        }
      });

    }

  }
  updateScript(id) {
    this.updateForm = true
    let selectedItem = this.testData.filter((f) => f.id === id);
    this.scriptDataById = JSON.parse(JSON.stringify(selectedItem));
    this.sqlDataForm.patchValue({
      name: selectedItem[0].name,
      settingName: selectedItem[0].settingName,
      query: selectedItem[0].query
    })
  }

  ClearForm() {
    this.loadForm();
    this.updateForm = false;
    this.default = '';
  }
}